import { Accordion, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function FaqSection() {
  const { t } = useTranslation();
  
  // Esto trae el array completo desde el JSON
  const faqs = t('faq_items', { returnObjects: true });

  return (
    <section className="py-5 bg-dark text-white" id="faq">
      <Container>
        <h2 className="mb-4 text-center">{t('preguntasfrecuentestitulo')}</h2>
        <Accordion defaultActiveKey={null} alwaysOpen={false}>
          {faqs.map((item, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>{item.question}</Accordion.Header>
              <Accordion.Body>
                {item.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}